<form class="p-3 flex flex-col justify-start items-stretch gap-2" [formGroup]="productForm">
  <mat-form-field appearance="outline" class="mini-input no-subcript">
    <mat-label i18n>Количество</mat-label>
    <input type="number" matInput formControlName="count" />
    <mat-error i18n *ngIf="productForm.get('count').hasError('required')">Поле не может быть пустым</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="mini-input no-subcript">
    <mat-label i18n>Ширина</mat-label>
    <input type="number" matInput formControlName="width" />
    <mat-error i18n *ngIf="productForm.get('width').hasError('required')">Поле не может быть пустым</mat-error>
    <mat-error i18n *ngIf="productForm.get('width').hasError('min')"
      >Минимальное значение ширины - {{ productForm.get('width').getError('min').min }}</mat-error
    >
    <mat-error i18n *ngIf="productForm.get('width').hasError('max')"
      >Максимальное значение ширины - {{ productForm.get('width').getError('max').max }}</mat-error
    >
  </mat-form-field>
  <mat-form-field appearance="outline" class="mini-input no-subcript">
    <mat-label i18n>Высота</mat-label>
    <input type="number" matInput formControlName="height" />
    <mat-error i18n *ngIf="productForm.get('height').hasError('required')">Поле не может быть пустым</mat-error>
    <mat-error i18n *ngIf="productForm.get('height').hasError('min')"
      >Минимальное значение ширины - {{ productForm.get('height').getError('min').min }}</mat-error
    >
    <mat-error i18n *ngIf="productForm.get('height').hasError('max')"
      >Максимальное значение ширины - {{ productForm.get('height').getError('max').max }}</mat-error
    >
  </mat-form-field>
  <mat-form-field appearance="outline" class="mini-input no-subcript">
    <mat-label i18n>Глубина</mat-label>
    <input type="number" matInput formControlName="deep" />
    <mat-error i18n *ngIf="productForm.get('deep').hasError('required')">Поле не может быть пустым</mat-error>
    <mat-error i18n *ngIf="productForm.get('deep').hasError('min')"
      >Минимальное значение ширины - {{ productForm.get('deep').getError('min').min }}</mat-error
    >
    <mat-error i18n *ngIf="productForm.get('deep').hasError('max')"
      >Максимальное значение ширины - {{ productForm.get('deep').getError('max').max }}</mat-error
    >
  </mat-form-field>
</form>
